// src/data/coachingAdvice.js
export const coachingAdvice = {
  EARLY_BLOOMER: {
    name: "早熟型（Fast Starter）",
    title: "「早熟型」のあなたへのコーチングTIPS",
    advice: [
      "「やってみせる（Demonstration）」: まずは完成形や理想の姿を見せることで、あなたの直感的な理解を加速させます。ロールモデルの模倣から始めましょう。",
      "「フィードバックループの高速化」: 短いサイクルで挑戦とフィードバックを繰り返し、勢いを維持することが重要です。完璧よりも完了を優先してください。",
      "「過信への注意喚起」: 初期段階での成功体験が過信に繋がらないよう、敢えて難しい課題や、異なる視点を与えてくれるメンターとの対話が、あなたをさらなる高みへと導きます。",
    ],
    icon: 'Rocket',
  },
  LATE_BLOOMER: {
    name: "遅咲き型（Late Bloomer）",
    title: "「遅咲き型」のあなたへのコーチングTIPS",
    advice: [
      "「段階的な足場の構築（Scaffolding）」: 複雑なスキルを細かく分解し、一つずつ着実に習得できる学習計画が有効です。焦る必要はありません。",
      "「心理的安全性の確保」: 初期段階での失敗を恐れずに試行錯誤できる、安全な環境が不可欠です。あなたのペースを尊重し、サポートしてくれる仲間を見つけましょう。",
      "「小さな成功体験の可視化」: 進捗が遅いと感じがちなため、日々の小さな進歩を記録し、可視化してあげることがモチベーション維持の鍵となります。",
    ],
    icon: 'Sprout',
  },
};
